import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [status, setStatus] = useState('idle');
  const [form, setForm] = useState({ name: '', email: '', message: '' });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    const data = new FormData();
    data.append('name', form.name);
    data.append('email', form.email);
    data.append('message', form.message);
    data.append('_captcha', 'false');
    data.append('_template', 'table');
    try {
      const res = await fetch('https://formsubmit.co/ajax/slokhand@buffalo.edu', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data,
      });
      const json = await res.json();
      if (json.success === 'true' || json.success === true) {
        setStatus('sent');
        setForm({ name: '', email: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-card">
        <h1 className="contact-title">Contact Me</h1>
        {status === 'sent' ? (
          <p className="contact-success">Thank you! I will get back to you soon.</p>
        ) : (
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="contact-row">
              <div className="contact-field">
                <label className="contact-label">Name</label>
                <input
                  className="contact-input"
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="contact-field">
                <label className="contact-label">Email</label>
                <input
                  className="contact-input"
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="contact-field">
              <label className="contact-label">Message</label>
              <textarea
                className="contact-textarea"
                name="message"
                rows="6"
                value={form.message}
                onChange={handleChange}
                required
              />
            </div>
            {status === 'error' && (
              <p className="contact-error">Something went wrong. Please try again.</p>
            )}
            <button className="contact-btn" type="submit" disabled={status === 'sending'}>
              {status === 'sending' ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Contact;
